(function () {
  function initCustomHeader() {
    const header = document.querySelector('.custom-header');
    if (!header) return;

    function setHeaderOffset() {
      const headerHeight = header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
      document.body.classList.add('has-fixed-header');
    }

    function handleStickyState() {
      if (window.scrollY > 10) {
        header.classList.add('is-sticky-scrolled');
      } else {
        header.classList.remove('is-sticky-scrolled');
      }

      setHeaderOffset();
    }

    const mobileMenu = header.querySelector('.custom-mobile-menu');
    const openMenuButton = header.querySelector('[data-mobile-menu-open]');
    const closeMenuButtons = header.querySelectorAll('[data-mobile-menu-close]');
    const openPanelButtons = header.querySelectorAll('[data-open-panel]');
    const backPanelButtons = header.querySelectorAll('[data-back-panel]');
    const panels = header.querySelectorAll('[data-menu-panel]');

    const mobileSearch = header.querySelector('.custom-header__mobile-search');
    const mobileSearchButton = header.querySelector('[data-mobile-search-open]');

    function resetPanels(activeName) {
      panels.forEach((panel) => {
        const panelName = panel.getAttribute('data-menu-panel');
        panel.classList.remove('is-active', 'is-left');

        if (panelName === activeName) {
          panel.classList.add('is-active');
        }
      });
    }

    function setActivePanel(targetName) {
      panels.forEach((panel) => {
        const panelName = panel.getAttribute('data-menu-panel');

        if (panel.classList.contains('is-active')) {
          panel.classList.remove('is-active');
          panel.classList.add('is-left');
        }

        if (panelName === targetName) {
          panel.classList.remove('is-left');
          panel.classList.add('is-active');
        }
      });
    }

    function openMenu() {
      if (!mobileMenu) return;
      mobileMenu.hidden = false;
      document.body.classList.add('mobile-menu-open');
      if (openMenuButton) openMenuButton.setAttribute('aria-expanded', 'true');
      resetPanels('root');
    }

    function closeMenu() {
      if (!mobileMenu) return;
      mobileMenu.hidden = true;
      document.body.classList.remove('mobile-menu-open');
      if (openMenuButton) openMenuButton.setAttribute('aria-expanded', 'false');
      resetPanels('root');
    }

    function toggleMobileSearch() {
      if (!mobileSearch || !mobileSearchButton) return;
      const isHidden = mobileSearch.hasAttribute('hidden');

      if (isHidden) {
        mobileSearch.removeAttribute('hidden');
        mobileSearchButton.setAttribute('aria-expanded', 'true');
      } else {
        mobileSearch.setAttribute('hidden', 'hidden');
        mobileSearchButton.setAttribute('aria-expanded', 'false');
      }
    }

    if (openMenuButton) {
      openMenuButton.addEventListener('click', openMenu);
    }

    closeMenuButtons.forEach((button) => {
      button.addEventListener('click', closeMenu);
    });

    openPanelButtons.forEach((button) => {
      button.addEventListener('click', function () {
        const target = this.getAttribute('data-open-panel');
        if (target) setActivePanel(target);
      });
    });

    backPanelButtons.forEach((button) => {
      button.addEventListener('click', function () {
        const target = this.getAttribute('data-back-panel');
        if (target) setActivePanel(target);
      });
    });

    if (mobileSearchButton) {
      mobileSearchButton.addEventListener('click', toggleMobileSearch);
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeMenu();
      }
    });

    window.addEventListener('scroll', handleStickyState, { passive: true });
    window.addEventListener('resize', setHeaderOffset);
    setHeaderOffset();
    handleStickyState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomHeader);
  } else {
    initCustomHeader();
  }
})();
